<app-logged-out [isSuccessfull]="true" [auto]="auto"></app-logged-out>
